window.gaDataDeploy = window.gaDataDeploy || {};
gaDataDeploy.config = window.gaDataDeploy.config || {};
gaDataDeploy.config.webstie_brand = "mommesilk_de";
gaDataDeploy.config.currency = "EUR";
gaDataDeploy.config.customer = gaDataDeploy.config.customer || "";
gaDataDeploy.config.pageType = gaDataDeploy.config.pageType || "";
gaDataDeploy.config.pageUrl = gaDataDeploy.config.pageUrl || "";
gaDataDeploy.config.productId = gaDataDeploy.config.productId || "";
gaDataDeploy.config.searchDrawer = {
		box:$("#search-box .predictive-results #PredictiveResults"),
		listName:"publicDrawerSearch_",
		recommendlistName:"publicDrawerSearchRecommend_",
};
gaDataDeploy.config.miniCartRecommendDrawer = {
		box:$(".cart-recommend-box"),
  		box_class:".cart-recommend-box",
		listName:"CartPopUp-Recommend",
};
gaDataDeploy.config.recentlyViewed = {
		box:$("#RecentlyViewed-recently-viewed"),
		listName:"Recently viewed",
};
gaDataDeploy.config.topPromotion = {
		box:$("#AnnouncementSlider"),
		item:".announcement-slider__slide",
};
gaDataDeploy.config.topPromotionDetail = {
		box:$(".activity-information-box"),
		item:".activity-information-container-text",
};
gaDataDeploy.config.homeRecommendCatalog = {
		box:$(".header-feature-advantage .advantage-img-box .grid-box"),
		item:".img-box-container",
};
gaDataDeploy.config.homeRecommendCatalog02_pc = {
		box:$(".product-feature-box.pc"),
		item:".left .product-name-box .product-name",
};
gaDataDeploy.config.homeRecommendCatalog02_mb = {
		box:$(".product-feature-box.mb .product-feature-box-container"),
		item:".swiper-slide",
};
gaDataDeploy.config.homeNetRed_pc = {
		box:$(".on-the-gram-box .on-the-gram-box-container.on-the-gram-box-container-pc"),
		item:".on-the-gram-box-img",
};
gaDataDeploy.config.homeNetRed_ipd = {
		box:$(".on-the-gram-box .on-the-gram-box-container.on-the-gram-box-container-ipd"),
		item:".on-the-gram-box-container-img>.img",
};
gaDataDeploy.config.homeNetRed_mb = {
		box:$(".on-the-gram-box .on-the-gram-box-container.on-the-gram-box-container-mb"),
		item:".on-the-gram-box-container-img>.img",
};
gaDataDeploy.config.topTitle = {
		box:$(".page-container"),
		parentItem:".site-nav__item",
		item:".site-nav__dropdown .grid__item",
};
gaDataDeploy.config.homeMainBanner = {
		box:$(".min-banner-box"),
		item:".image a",
};
gaDataDeploy.config.homeThreeImageGrid = {
		box:$(".three_image_grid"),
		item:".three-image-image",
};
gaDataDeploy.config.productRecommend = {
		box:".product-recommendations",
		listName:"YouMayAlsoLike-product",
};


if(gaDataDeployConfigBase)
{
	$.extend( gaDataDeploy.config, gaDataDeployConfigBase );
}

gaDataDeploy.init = function(sectionObj)
{
	// 产品列表事件 -- 基础 
	$("div[data-section-type='collection-template']").each(function(){
		gaDataDeploy.collectionInit($(this));
	})
	// 产品列表事件 -- 弹框搜索列表 产品轮播在此处获取不到 所以代码写在 theme.searchDrawers	
	
	// 产品详情事件
	if(gaDataDeploy.config.pageType == "product")
		gaDataDeploy.productDetailDeploy(gaDataDeploy.config.productId);
	/**
	小购物车事件埋点写在 theme.CartD  里面了
	gaDataDeploy.cartDeploy
	**/
	// 大购物车事件
	if(gaDataDeploy.config.pageType == "cart")
		gaDataDeploy.cartPageDeploy();
  
  	// checkout 事件
  	gaDataDeploy.checkOutDeploy();

	// 非电商监测事件
	gaDataDeploy.elementClick();
};
/**
 * 产品列表注册事件
 */
gaDataDeploy.collectionInit = function(collectionObj)
{
	var pageType = gaDataDeploy.config.pageType ;
	var listName = pageType == "index" ? "Home" : pageType;
	var headTitle = $.trim(collectionObj.find(".section-header__title").text());
	var searchKey = $.trim($(".main-content").find(".search-terms .terms").text()); 
	//var collectionTitle = $.trim($(".main-content").find(".collection_title").text());	
	var collectionTitle = $.trim($(".main-content").find(".crumbs-collection-names").text());
	
	if(searchKey)
		listName = listName + "_" + searchKey;
	else if(headTitle)
		listName = listName + "_" + headTitle;
	else if(collectionTitle)
	{
		listName = listName + "_" + collectionTitle;
		var dataCollectionHandle = collectionObj.attr("data-collection-handle");
		if(dataCollectionHandle)
		{
			var collectionSubtitle = $.trim($(".main-content").find(".collection-button-box .collection-button-item[data-handle='"+dataCollectionHandle+"']").text());
			if(collectionSubtitle)
				listName = listName + "_" + collectionSubtitle;
		}
	}
	else if(pageType == "index")
		listName = listName + "_recommend"
	gaDataDeploy.productListDeploy(collectionObj,listName);
}
/*
 * 判断指定元素 是否在可视区域
 * itemObj 指定的元素
 * height 元素至少展示的高度 默认为哦
 * parentsObj 基于次类进行判断item的展示情况  默认按照window
 *
 * retuen boole  true false
 */
gaDataDeploy.itemIsEyeShow = function(itemObj,height,parentsObj)
{
	if(!height)
		height = 0;
  	height = parseInt(height)
	var winScrollTop = $(window).scrollTop();
  	//优先判断产品是否是隐藏或者透明了
	if(itemObj.is(":hidden") || itemObj.css("display") == "none"  || itemObj.css("opacity") == "0")
		return false;
  
	var isParent = false;
	if(typeof parentsObj == "object")
	{
		// 先判断父类是否已经展示出来了
		if(!gaDataDeploy.itemIsEyeShow(parentsObj))
		{
			//console.log("父类未显示")
			return false;
		}
		isParent = true;
		var parentsOffset = parentsObj.offset();
		var parentsTop = parentsOffset.top - winScrollTop;
		var parentsLeft = parentsOffset.left;
		
		var winH = $(window).height();
		var winW = $(window).width();
		var winB = winScrollTop + winH;
	}
	else
	{
		parentsObj = $(window);
		var parentsTop = winScrollTop;
		var parentsLeft = 0;
	}
	
	var parentsH = parentsObj.height();
	var parentsW = parentsObj.width();
	var parentsB = parentsTop + parentsH;
	
	var itemOffset = itemObj.offset();
	var itemTop = itemOffset.top - winScrollTop;
	var itemOffTop = itemOffset.top;
	var itemLeft = itemOffset.left;
	var itemH = itemObj.outerHeight(true);
	var itemW = itemObj.outerWidth(true);
	
	if(!isParent)
	{
		//上下基于window   左右基于分类
		/**
		 上下
		 item 的 top小于 winH
		 item 的 0
		 
		 左右
		 item 的 left 小于 pLeft + pWidth
		 item 的 right 大于 pLeft
		 **/	
		if((itemTop + height) <= parentsH && (itemTop + itemH - height) >= 0 && ((itemLeft + itemW) > parentsLeft && itemLeft < (parentsW + parentsLeft)))
		{
			return true;	
		}
	}
	else
	{
		// 判断子是否在视线内
		if(!gaDataDeploy.itemIsEyeShow(itemObj,height))
		{
			//console.log("子类未显示")	
			return false;	
		}
		else
		{
			//上下基于父类   左右基于分类
			/**
			 上下
			 item 的 top小于 pTop + pHeight
			 item 的 bottom 大于 pTop
			 
			 左右
			 item 的 left 小于 pLeft + pWidth
			 item 的 right 大于 pLeft
			 **/	
			if((itemTop + height) <= (parentsTop + parentsH) && (itemTop + itemH - height) >= parentsTop && ((itemLeft + itemW) >parentsLeft && itemLeft < (parentsW + parentsLeft)))
			{
				return true;	
			}	
		}
		
		
	}
	return false;	
};
/*
 * 产品数据规整
 * retuen {}
 */
gaDataDeploy.productTidy = function(data)
{
	var gaProductItem = {};
	data["name"] ? gaProductItem["name"] = data["name"] : data["title"] && (gaProductItem["name"] = data["title"]);
	data["id"] ? gaProductItem["id"] = data["id"] : data["spu"] && (gaProductItem["id"] = data["spu"]);
	data["simple_product"] ? gaProductItem["simple_product"] = data["simple_product"] : data["sku"] && (gaProductItem["simple_product"] = data["sku"]);
	data["price"] ? gaProductItem["price"] = data["price"] : data["price"] && (gaProductItem["price"] = data["price"]);
	typeof(data["category"]) != "undefined" ? gaProductItem["category"] = data["category"] : typeof(data["pact"]) != "undefined" && (gaProductItem["category"] = data["pact"]);
	data["list"] ? gaProductItem["list"] = data["list"] : data["list"] && (gaProductItem["list"] = data["list"]);
	data["position"] ? gaProductItem["position"] = data["position"] : data["position"] && (gaProductItem["position"] = data["position"]);
	data["variant"] ? gaProductItem["variant"] = data["variant"] : data["variant"] && (gaProductItem["variant"] = data["variant"]);
    // variant json转化下
	if(gaProductItem["variant"] && typeof(gaProductItem["variant"]) != "string")
	{
		var variantArr = [];
		$.each(data["variant"],function(k,v){
			variantArr.push(k + ":"+v);
		})
		var variantStr = variantArr.join('_');
		if(variantStr)
			gaProductItem["variant"] = variantStr;
	}
	data["quantity"] ? gaProductItem["quantity"] = data["quantity"] : data["quantity"] && (gaProductItem["quantity"] = data["quantity"]);
	data["brand"] ? gaProductItem["brand"] = data["brand"] : gaProductItem["brand"] = gaDataDeploy.config.webstie_brand;
	return gaProductItem;
};
/*
 * 产品数据 json  因为有些地方数据需要在前台整理
 * retuen {}
 */
gaDataDeploy.getGaProductData = function(productData)
{
	var gaData = {};
	var pact = gaDataDeploy.getGaProductPact(productData);
	var fitstVariants = productData["variants"][0];
	var title = productData["title"];
    var category = productData["product_type"];
	var sku = fitstVariants["sku"];
	var price = fitstVariants["price"];
	var url = "/products/"+productData["handle"];
	var skuList = sku.split("-");
	var spu = skuList[0];
	
  	var reg = new RegExp("'","g");
    title = title.replace(reg,"");
	gaData["pact"] = pact;
	gaData["spu"] = spu;
	gaData["title"] = title;
    gaData["category"] = category;
	gaData["sku"] = sku;
	gaData["price"] = price;
	gaData["url"] = url;
	return gaData;
};
/*
 * 产品数据 json  因为有些地方数据需要在前台整理  购物车版
 * retuen {}
 */
gaDataDeploy.getGaProductDataCart = function(productData)
{
	var gaData = {};
	var pact = gaDataDeploy.getGaProductPact(productData);
	var title = productData["title"].replace(" - "+productData["variant_title"],"");
    var category = productData["product_type"];
	var sku = productData["sku"];
	var price = productData["price"] / 100;
	var url = productData["url"];
	var skuList = sku.split("-");
	var spu = skuList[0];
	var variant = {};
	var options_with_values = productData["options_with_values"];
	$.each(options_with_values,function(k,v){
		variant[v["name"]] = v["value"];
	})
	var quantity = productData["quantity"];
	
	gaData["pact"] = pact;
	gaData["spu"] = spu;
	gaData["title"] = title;
    gaData["category"] = category;
	gaData["sku"] = sku;
	gaData["price"] = price;
	gaData["url"] = url;
	gaData["variant"] = variant;
	gaData["quantity"] = quantity;
	return gaData;
};
// 获取产品的 pact
gaDataDeploy.getGaProductPact = function(product)
{
	var product_pcat_type = product["product_type"];
	if (product_pcat_type == "Accessories" || product_pcat_type == "Sleep Hair Cap" || product_pcat_type == "facemask" || product_pcat_type == "scrunchies" || product_pcat_type == "sleep masks")
		product_pcat_type = "Accessories"
	else if( product_pcat_type == "Bundle" || product_pcat_type == "pillowcase")
    	product_pcat_type = "Pillowcase_collection"
    else if( product_pcat_type == "bedding" || product_pcat_type == "beddingset")
    	product_pcat_type = "Bedding"
    else if( product_pcat_type == "comforter")
    	product_pcat_type = "Comforters"
    else if( product_pcat_type == "custom" || product_pcat_type == "pajamas" || product_pcat_type == "pajamasset")
    	product_pcat_type = "Sleepwear"
    else if( product_pcat_type == "maskandpillowcase")
    	product_pcat_type = "Pillowcase_Eyemask"
    
	return product_pcat_type
}

/**
 * 公共数据更新方法
 *
 */
gaDataDeploy.dataUpdate = function(){
	
}

// 产品列表埋点
gaDataDeploy.productListDeploy = function(listObj,listName,funcName)
{
	var config = {
		productClass : ".grid__item.grid-product",
		showTop : 100,
		showAttr : "ga_show",
		productListObj:"",
		productListName:"",
		productObj:""
	};
	var that;
	function productListDeploy(listObj,listName)
	{
		config.productListObj = listObj;
		config.productListName = listName;
		config.productObj = config.productListObj.find(config.productClass);
		if(listObj.attr("id") == "RecentlyViewed-recently-viewed")
			config.productObj = config.productListObj.find(".grid-product__content");
		else if(listObj.parents("#search-box").length > 0)
			config.productObj = config.productListObj.find(".productItem");
      	else if(listObj.parents("#CartDrawer").length > 0)
        {
			config.productObj = config.productListObj.find(".mini-product-item-variant");
        }
     
	}
	var productListDeploy = new productListDeploy(listObj,listName);
	productListDeploy = Object.assign({},productListDeploy,{
		init:function(){
			that = this;
			this.itemShow();
			this.itemClick();
		},
		// 产品展示事件 列表展示   
		itemShow:function(){
			
			$(window).scroll(function(){
				that.itemShowAction();
			})
			$(window).resize(function(){
				that.itemShowAction();
			})
			var itemMousedown = false;
			// 按下
			config.productListObj.on("touchstart mousedown",config.productClass,function(e){
				itemMousedown = true;
				//console.log("按下");
			})
			// 触摸移动时
			config.productListObj.on("mousemove touchmove",config.productClass,function(e){
				//console.log("移动");
				if(itemMousedown && e.which == 1)
					that.itemShowAction();
			})
			//抬起
			config.productListObj.on("touchend mouseup",config.productClass,function(e){
				itemMousedown = false;
			})
			
			this.itemShowAction();
		},
		itemShowAction:function(){
			function productItemEye()
			{
				var gaProductData = [];
				config.productObj.not('['+config.showAttr+']').each(function(){
					//if(gaDataDeploy.itemIsEyeShow($(this),config.showTop),config.productListObj)
					// 基于父类的先暂停  轮播的触摸事件不方便调用  暂时没想法 先搁置 黄康 2021-09-02
					if(gaDataDeploy.itemIsEyeShow($(this),config.showTop))
					{
						var itemObj = $(this)
						var productData = that.getItemData(itemObj);
						if(!productData)
							return false;
						
						$(this).attr(config.showAttr,true);
						productData["list"] = config.productListName;
						gaProductData.push(gaDataDeploy.productTidy(productData));	
					}
				})
				
				if(gaProductData.length > 0)
				{
					var gaData = {"detail":[],"products":[]};
					gaData["products"] = gaProductData;
					
					var gaDataDetail = [];
					gaDataDetail["pcat"] = "";
					gaDataDetail["ecomm_proid"] = "";
					gaDataDetail["PageGroup1"] = "";
					gaDataDetail["PageGroup2"] = "";
					gaDataDetail["PageGroup3"] = "";
					gaData["detail"] = gaDataDetail;
					
					gaDataDeploy.publicDeploy().productEyeShow(gaData);
				}
			}
			productItemEye();
		},
		
		//产品点击事件
		itemClick:function(){
			
			var gaData = {"detail":[],"products":[],"actionField":{}};
			config.productObj.click(function(event){
				var gaProductData = [];
				// 判断是否跳转 不跳转不触发此事件
				if(config.productObj.find("a").find(event.target).length <= 0)
					return true;
					
				var itemObj = $(this)
				var productData = that.getItemData(itemObj);
				if(!productData)
					return true;
				gaProductData.push(gaDataDeploy.productTidy(productData));				
				
				gaData["products"] = gaProductData;
				gaData["actionField"]["list"] = config.productListName;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productClick(gaData);
			})
		},
		// 获取产品信息
		getItemData:function(itemObj){
						
			var productData = itemObj.attr("data-product-data");
			if(!productData)
				 return false;
			productData = JSON.parse(productData)
			
			var position = itemObj.index();
			if(itemObj.attr("data-swiper-slide-index"))
				position = itemObj.attr("data-swiper-slide-index");
			else if(itemObj.parents("[data-swiper-slide-index]").length > 0)
				position = itemObj.parents("[data-swiper-slide-index]").attr("data-swiper-slide-index");
			else if(itemObj.attr("data-slick-index"))
				position = itemObj.attr("data-slick-index");
			else if(itemObj.parents("[data-slick-index]").length > 0)
				position = itemObj.parents("[data-slick-index]").attr("data-slick-index");
			position = parseInt(position) + 1;
				
			productData["position"] = position;
			var color = itemObj.find(".grid-product__colors .color-swatch--small.is-active").data("value");
			var variant = {};
			color && (variant["color"] = color);
			productData["variant"] = variant;
			
			return productData;
		},
		
	});
	if(funcName == "itemShowAction")
		productListDeploy.itemShowAction();
	else
		productListDeploy.init();
		
	return productListDeploy ;
};

// 产品详情埋点
gaDataDeploy.productDetailDeploy  = function(productId)
{
	
	var config = {
		product:"div.product-section[data-product-data]",
		productForm:".product-single__form",
		paypalButton:".payment-buttons .shopify-payment-button",
	};
	var that;
	function productDetailDeploy()
	{
		config.thatProductObj = $(config.product+"#ProductSection-"+productId)
	}
	var productDetailDeploy = new productDetailDeploy();
	productDetailDeploy = Object.assign({},productDetailDeploy,{
		init:function(){
			that = this;
			this.itemShow();
			this.itemAddCart();
			this.itemPaypalClick();
		},
		// 产品详情展示事件
		itemShow:function(){
			
			var gaData = {"detail":[],"products":[]};
			var gaProductData = [];
			var thatProduct = config.product;
			var thatProductObj = config.thatProductObj;
			var thatProductForm = config.productForm;
			
			if(thatProductObj.length > 0)
			{
				var itemObj = thatProductObj;
				var productData = that.getItemData(itemObj);
				if(!productData)
					return false;
				
				delete productData["quantity"];
				gaProductData.push(gaDataDeploy.productTidy(productData));
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["spu"];				
				
				gaData["detail"] = gaDataDetail;
				gaDataDeploy.publicDeploy().productDetail(gaData);
			}
		},
		// 加购事件  
		itemAddCart:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
			var thatProductObj = config.thatProductObj;
			var thatProductForm = config.productForm;
			
			thatProductObj.find(thatProductForm).on("click","button[type='submit'].add-to-cart:not('.disabled')",function(){
			//$(thatProductForm).find("button[type='submit'].add-to-cart").not('.disabled').click(function(){
				
				var gaProductData = [];
				var itemObj = $(this).parents(thatProduct);
				var productData = that.getItemData(itemObj);
				if(!productData)
					return false;
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productAddCart(gaData);
			})
				

		},
		//产品paypal点击事件
		itemPaypalClick:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
			var thatProductObj = config.thatProductObj;
			var thatProductForm = config.productForm;
			var thatProductPaypalBtn = config.paypalButton;
			
			thatProductObj.find(thatProductForm).on("click",thatProductPaypalBtn,function(){
				var gaProductData = [];
				var itemObj = $(this).parents(thatProduct)
				var productData = that.getItemData(itemObj);
				if(!productData)
					return false;
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().checkoutStep01(gaData);
				gaDataDeploy.publicDeploy().checkoutStep02(gaData);
				gaDataDeploy.publicDeploy().checkoutStep03(gaData);
			})
		},
		// 获取产品信息
		getItemData:function(itemObj){
			
			var thatProductForm = config.productForm;	
			var productData = itemObj.attr("data-product-data");
			if(!productData)
				 return false;
			productData = JSON.parse(productData)
			var variant = {};	 
			itemObj.find(thatProductForm).find(".variant-wrapper--button").each(function(){
				var variantItem = $(this).find("input[type='radio']:checked")
				variant[variantItem.attr("name")] = variantItem.val();
			})
			productData["variant"] = variant;
			var quantity = itemObj.find(thatProductForm).find("input[name='quantity']").val();
			productData["quantity"] = quantity ? quantity : 1;

			//console.log(productData)
			return productData;
		}
		
	});
	productDetailDeploy.init();
	return productDetailDeploy ;
},

// 小购物车埋点
gaDataDeploy.cartDeploy  = function()
{
	var config = {
		cartDrawer:"#CartDrawer",
		addBtn:".js-qty__adjust--plus",
		minuBtn:".js-qty__adjust--minus",
		removeBtn:".remove-product",
		product:".ajaxcart__product"
	};
	var that;
	function cartDeploy()
	{
		config.cartDrawerObj = $(config.cartDrawer);
		config.addBtnObj = config.cartDrawerObj.find(config.addBtn);
		config.minuBtnObj = config.cartDrawerObj.find(config.minuBtn);
		config.removeBtnObj = config.cartDrawerObj.find(config.removeBtn);
	}
	var cartDeploy = new cartDeploy();
	cartDeploy = Object.assign({},cartDeploy,{
		init:function(){
			that = this;
			this.itemAddCart();
			this.itemRemoveCart();
		},
		// 加购事件  
		itemAddCart:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
          
			config.addBtnObj.click(function(){
				var itemObj = $(this).parents(thatProduct);
				var gaProductData = [];	
				var productData = that.getItemData(itemObj);
				if(!productData)
                     return false;
				
				productData["quantity"] = 1;
				//console.log(productData)
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productAddCart(gaData);
			})
				
		},
		// 减购或者删除事件  
		itemRemoveCart:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
			
			config.cartDrawerObj.find(config.minuBtn+" , "+config.removeBtn).click(function(event){
			//config.cartDrawerObj.on("click",config.minuBtn+" , "+config.removeBtn,function(event){
				var itemObj = $(this).parents(thatProduct);
				var gaProductData = [];	
				var productData = that.getItemData(itemObj);
				if(!productData)
                     return false;
					 
				if($(this).hasClass("js-qty__adjust--minus"))
					productData["quantity"] = 1;
				else if($(this).hasClass("ajaxcart__product"))
					productData["quantity"] = productData["quantity"];
				//console.log(productData)
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productReomveCart(gaData);
			})
				
		},
		// 获取产品信息
		getItemData:function(itemObj){
			
			var gaProductData = [];				
			var productData = itemObj.attr("data-product-data");
			if(!productData)
				 return false;
			productData = JSON.parse(productData)
			
			//console.log(productData)
			return productData;
		}
	});
	cartDeploy.init();
	return cartDeploy ;
},
//  小购物车 推荐产品埋点
gaDataDeploy.cartRecommendDeploy  = function()
{
	var config = {
		cartDrawer:"#CartDrawer",
		productForm:"form[action='/cart/add']",
		product:".mini-product-item-variant",
	};
	var that;
	function cartRecommendDeploy()
	{
		config.cartDrawerObj = $(config.cartDrawer);
		config.productFormObj = $(config.cartDrawer).find(config.product).find(config.productForm);
	}
	var cartRecommendDeploy = new cartRecommendDeploy();
	cartRecommendDeploy = Object.assign({},cartRecommendDeploy,{
		init:function(){
			that = this;
			this.itemAddCart();
		},
		// 加购事件  
		itemAddCart:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
			
			config.productFormObj.submit(function(){
				var itemObj = $(this).parents(thatProduct);
				var gaProductData = [];	
				var productData = that.getItemData(itemObj);
				if(!productData)
                     return false;
				
				productData["quantity"] = 1;
				//console.log(productData)
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productAddCart(gaData,gaDataDeploy.config.miniCartRecommendDrawer.listName);
			})
				
		},
		// 获取产品信息
		getItemData:function(itemObj){
			
			var thatProductForm = config.productForm;	
			var productData = itemObj.attr("data-product-data");
			if(!productData)
				 return false;
			productData = JSON.parse(productData)
			var variant = {};	 
			itemObj.find(thatProductForm).find(".grid-product--variant-box .grid-product--option").each(function(){
				var variantItem = $(this).find(".grid-product--option-title .grid-product--option-value")
				variant[$(this).attr("data-option-name")] = variantItem.text();
			})
			productData["variant"] = variant;
			var quantity = itemObj.find(thatProductForm).find("input[name='quantity']").val();
			productData["quantity"] = quantity ? quantity : 1;

			//console.log(productData)
			return productData;
		}
	});
	cartRecommendDeploy.init();
	return cartRecommendDeploy ;
},  
// 大购物车埋点
gaDataDeploy.cartPageDeploy  = function()
{
	var config = {
		box:".main-content",
		removeBtn:".deleteRemove",
		addBtn:".qty--plus",
		minuBtn:".qty--minus",
		product:".cart__row[data-product-data]",
		productQty:".grid-number-pc .number"
	};
	var that;
	function cartPageDeploy()
	{
		config.boxObj = $(config.box);
		config.removeBtnObj = config.boxObj.find(config.removeBtn);
      	config.addBtnObj = config.boxObj.find(config.addBtn);
	}
	var cartPageDeploy = new cartPageDeploy();
	cartPageDeploy = Object.assign({},cartPageDeploy,{
		init:function(){
			that = this;
			this.itemRemoveCart();
          	this.itemAddCart(); 
		},
		// 加购事件  
		itemAddCart:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
          
			config.addBtnObj.click(function(){
				var itemObj = $(this).parents(thatProduct);
				var gaProductData = [];	
				var productData = that.getItemData(itemObj);
				if(!productData)
                     return false;
				
				productData["quantity"] = 1;
				//console.log(productData)
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productAddCart(gaData);
			})
				
		},
		// 减购或者删除事件  
		itemRemoveCart:function(){
			var gaData = {"detail":[],"products":[]};
			var thatProduct = config.product;
			
			//config.removeBtnObj.click(function(event){
			config.boxObj.find(config.minuBtn+" , "+config.removeBtn).click(function(event){
				
				var itemObj = $(this).parents(thatProduct);
				var gaProductData = [];	
				var productData = that.getItemData(itemObj);
				if(!productData)
                     return false;
				
				if($(this).hasClass("qty--minus"))
					productData["quantity"] = 1;
				else
					productData["quantity"] = itemObj.find(config.productQty).eq(0).text();
               
				gaProductData.push(gaDataDeploy.productTidy(productData));	
					
				gaData["products"] = gaProductData;
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = productData["pcat"];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().productReomveCart(gaData);
			})
				
		},
		// 获取产品信息
		getItemData:function(itemObj){
			
			var gaProductData = [];				
			var productData = itemObj.attr("data-product-data");
			if(!productData)
				 return false;
			productData = JSON.parse(productData)
			
			//console.log(productData)
			return productData;
		}
	});
	cartPageDeploy.init();
	return cartPageDeploy ;
},
// checkout埋点
gaDataDeploy.checkOutDeploy  = function()
{
	var config = {
		checkButton:"form[action='/cart']",
		product:".cart__row[data-product-data],.ajaxcart__product[data-product-data]",
		paypalButton:".payment-buttons .shopify-payment-button",
	};
	var that;
	function checkOutDeploy()
	{
		config.checkButtonObj = $(config.checkButton);
	}
	var checkOutDeploy = new checkOutDeploy();
	checkOutDeploy = Object.assign({},checkOutDeploy,{
		init:function(){
			that = this;
			this.checkClick();
			//this.paypalClick();
		},
		checkClick:function(){
			config.checkButtonObj.submit(function(){
              	var gaData = {"detail":[],"products":[]};
                /*
				$(this).find(config.product).each(function(k,v){
					var itemObj = $(this);
					var gaProductData = [];				
					var productData = itemObj.data("product-data");
					if(!productData)
						 return false;
	
					gaProductData.push(gaDataDeploy.productTidy(productData));	
						
					gaData["products"] = gaProductData;
					
					var gaDataDetail = [];
					gaDataDetail["productId"] = "";
					gaDataDetail["pcat"] = "";
					gaDataDetail["ecomm_proid"] = "";
					gaDataDetail["PageGroup1"] = "";
					gaDataDetail["PageGroup2"] = "";
					gaDataDetail["PageGroup3"] = "";
					gaData["detail"] = gaDataDetail;
					
					gaDataDeploy.publicDeploy().checkoutStep01(gaData);
					gaDataDeploy.publicDeploy().checkoutStep02(gaData);
				})
				*/
				var gaProductData = [];	
				var gaDataDetail = [];	
				$(this).find(config.product).each(function(k,v){
					var itemObj = $(this);
							
					var productData = itemObj.data("product-data");
					if(!productData)
						 return false;
					gaProductData.push(gaDataDeploy.productTidy(productData));		
				})
				
				gaData["products"] = gaProductData;
				
				gaDataDetail["productId"] = "";
				gaDataDetail["pcat"] = "";
				gaDataDetail["ecomm_proid"] = "";
				gaDataDetail["PageGroup1"] = "";
				gaDataDetail["PageGroup2"] = "";
				gaDataDetail["PageGroup3"] = "";
				gaData["detail"] = gaDataDetail;
				gaDataDeploy.publicDeploy().checkoutStep01(gaData);
				gaDataDeploy.publicDeploy().checkoutStep02(gaData);
			})
		},
		paypalClick:function(){
			
		}
	});
	checkOutDeploy.init();
	return checkOutDeploy ;
},
// 展示监控事件
/**
item 里面要加 ga-name  ga-id  属性
data {"creative":"Home_Banner","positionPrefix":"Home_Banner"}
*/
gaDataDeploy.otherShowDeploy = function(box,item,data)
{
	var config = {
		boxObj:"",
		showAttr:"ga_show",
		item:"",
		data:"",
		ga_name_attr:"data-ga-name",
		ga_id_attr:"data-ga-id",
	}
	var that;
	function otherShowDeploy()
	{
		config.boxObj = box;
		config.item = item;
		config.data = data
	}
	var otherShowDeploy = new otherShowDeploy();
	otherShowDeploy = Object.assign({},otherShowDeploy,{
		init:function(){
			that = this;
			this.itemShow();
            this.itemClick();
		},
		itemShow:function(){
			
			this.itemShowAction();
          	$(window).scroll(function(){
				that.itemShowAction();
			})
			$(window).resize(function(){
				that.itemShowAction();
			})
		},
		itemShowAction:function(){
			function itemEye()
			{
				var gaItemData = [];
				config.boxObj.find(config.item).not('['+config.showAttr+']').each(function(){
					//if(gaDataDeploy.itemIsEyeShow($(this),config.showTop),config.productListObj)
					// 基于父类的先暂停  轮播的触摸事件不方便调用  暂时没想法 先搁置 黄康 2021-09-02
                    if(gaDataDeploy.itemIsEyeShow($(this),config.showTop,config.boxObj))
					{
						var itemObj = $(this)
						$(this).attr(config.showAttr,true);
						
						itemData = that.getItemData(itemObj);
						itemData["position"] = config.data.positionPrefix + itemData["position"];
						gaItemData.push(itemData);	
					}
				})
				
				if(gaItemData.length > 0)
				{
					var gaData = {"detail":[],"items":[]};
					gaData["items"] = gaItemData;
					
					var gaDataDetail = [];
					gaData["detail"] = gaDataDetail;
					
					gaDataDeploy.publicDeploy().promotion(gaData);
				}
			}
			itemEye();
		},
		itemClick:function(){
			
			config.boxObj.on("click",config.item,function(){
              	var gaItemData = [];
				var itemObj = $(this)
				itemData = that.getItemData(itemObj);
				itemData["position"] = config.data.positionPrefix + itemData["position"];
				gaItemData.push(itemData);	
				
				var gaData = {"detail":[],"items":[]};
				gaData["items"] = gaItemData;
				
				var gaDataDetail = [];
				gaData["detail"] = gaDataDetail;
				
				gaDataDeploy.publicDeploy().promotionClick(gaData);
			})
			
		},
		// 获取信息
		getItemData:function(itemObj){
			
			var itemData = {};				
			
			itemData["name"] = itemObj.attr(config.ga_name_attr);
			itemData["id"] = itemObj.attr(config.ga_id_attr);
          	(!itemData["name"] && config.data["name"]) && (itemData["name"] = config.data["name"]);
			(!itemData["id"] && config.data["id"]) && (itemData["id"] = config.data["id"]);
            
          	if(itemData["name"] == itemData["id"] && itemObj.find("a").length > 0 && itemObj.find("a").attr("href"))
			{
				itemData["name"] = itemObj.find("a").attr("href");	
			}
			itemData["creative"] = config.data["creative"];
			
			var position = itemObj.index();
			
			if(itemObj.attr("data-swiper-slide-index"))
				position = itemObj.attr("data-swiper-slide-index");
			else if(itemObj.parents("[data-swiper-slide-index]").length > 0)
				position = itemObj.parents("[data-swiper-slide-index]").attr("data-swiper-slide-index");
			else if(itemObj.attr("data-slick-index"))
				position = itemObj.attr("data-slick-index");
			else if(itemObj.parents("[data-slick-index]").length > 0)
				position = itemObj.parents("[data-slick-index]").attr("data-slick-index");

			position = parseInt(position) + 1;
			itemData["position"] = position;
			//console.log(itemData)
			return itemData;
		}
	})
	otherShowDeploy.init();
	return otherShowDeploy ;
},


//非电商事件监测 -- 点击
gaDataDeploy.elementClick = function(noInit)
{		
	var configData = {	
		NewsletterPopup:$("#NewsletterPopup-newsletter-popup")
	}
	var that;
	function elementClick()
	{
      
	}
	var defaultSpeed = 1000;
	function setTimeFunction(func,speed)
	{
		speed = speed ? speed : defaultSpeed;
		setTimeout(func,speed)	
	}
	function getDomText(obj)
	{
		var text = ""
		$.each(obj.contents(),function(){
			if(this.nodeType === 3)
       		{
				text = $(this).text();
				return false;
			}
		})
		/*
		var text = obj.contents().filter(function() {
				return $.trim(this.nodeType === 3);
			}).text();	
		*/
		return $.trim(text);
	}
	var elementClick = new elementClick();
	elementClick = Object.assign({},elementClick,{
      	
		//积分插件
		rewardEvent:function(){
			var rewardLauncher = "#smile-ui-container";
			if($(rewardLauncher).length > 0)
			{
				
                SmileUI.ready().then(smileUiInstance => {
					that.rewardEventAction();
				}).catch(err => {
				  console.log("SmileUI 出现错误");
				  setTimeFunction(that.rewardEvent);
				});
			}
			else
			{
				setTimeFunction(that.rewardEvent)
			}
		},
		//积分插件
		rewardEventAction:function(){
			var rewardLauncher = "#smile-ui-container";
			var rewardLauncherFrame = "#smile-ui-container .smile-launcher-frame";
			var rewardLauncherFrameObj = $("body").find(rewardLauncherFrame).contents();
          	var isRewardPanelEventAction = false; //判断是否已经执行了  Panel
			
			// 打开
			rewardLauncherFrameObj.on("click",".launcher-container.launcher-open",function(event){
              	//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false

				var gaData = {"eventCategory":"Floating_Rewards","eventAction":"Click","eventLabel":"Rewards","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
				
              	that.rewardPanelEventAction();
			})
			// 关闭
			rewardLauncherFrameObj.on("click",".launcher-container.launcher-closed",function(event){
				
				//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
				
				var gaData = {"eventCategory":"Popover_Rewards","eventAction":"Close","eventLabel":"Popover_Close","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		// 积分打开后
		rewardPanelEventAction:function(){
			var rewardPanelFrame = ".smile-panel-frame";
			var rewardPanelFrameObj = $("body").find(rewardPanelFrame).contents();
			
			if(rewardPanelFrameObj.length > 0 )
			{
				//加载 Panel事件
				var gaData = {"eventCategory":"Popover_Rewards","eventAction":"View","eventLabel":"Popover_Rewards","eventNoninteraction":"1"}
				that.dataLayerPush(gaData);
				
				// 关闭事件
				rewardPanelFrameObj.on("click",".panel-fixed-header .close-btn",function(){
					var gaData = {"eventCategory":"Popover_Rewards","eventAction":"Close","eventLabel":"Popover_Close","eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
				
				// 登录事件
				rewardPanelFrameObj.on("click",".panel-container .panel-card-container .join-program-card a.btn",function(){
					var gaData = {"eventCategory":"Popover_Rewards","eventAction":"Click","eventLabel":"Join now","eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
				// 注册
				rewardPanelFrameObj.on("click",".panel-container .panel-card-container .join-program-card .body-1 a",function(){
					var gaData = {"eventCategory":"Popover_Rewards","eventAction":"Click","eventLabel":"Sign in","eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
			}
			else
			{
				setTimeFunction(that.rewardPanelEventAction)
			}
		},
		// 聊天插件
		livechatEvent:function(){
          	var livechatIsload = false;
			$("body").on("click","#reamazejs-container #reamaze-widget",function(){
				// 关闭
				if($(this).find("#reamaze-widget-icon svg").length > 0)
				{
					var gaData = {"eventCategory":"Popover_Livechat","eventAction":"Close","eventLabel":"Popover_Livechat","eventNoninteraction":"0"}
					
					that.dataLayerPush(gaData);
				}
				else
				{
					// 打开
					var gaData = {"eventCategory":"Floating_Livechat","eventAction":"Click","eventLabel":"Livechat","eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
					if(!livechatIsload)
                    {
                    	that.livechatPopupEvent();
						livechatIsload = true;
                    }
						
				}
			})
		},
		// 聊天 弹框事件
		livechatPopupEvent:function(){
			var reamazePopup = "#reamaze-popup";
			var reamazePopupFrame = reamazePopup+" iframe";
			var reamazePopupFrameObj = $("body").find(reamazePopupFrame).contents();
			
			if(reamazePopupFrameObj.length > 0 )
			{
				//加载 popup 事件
				var gaData = {"eventCategory":"Popover_Livechat","eventAction":"View","eventLabel":"Popover_Livechat","eventNoninteraction":"1"}
				that.dataLayerPush(gaData);
				
				//关闭
				$(reamazePopup).on("click","#reamaze-container>a.anim-btn",function(){
					var gaData = {"eventCategory":"Popover_Livechat","eventAction":"Close","eventLabel":"Popover_Livechat","eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
				//点击分享
				reamazePopupFrameObj.on("click","#misc-channels>.anim-btn",function(){
					var name = $(this).attr("title");
					var gaData = {"eventCategory":"Popover_Livechat","eventAction":"Social","eventLabel":name,"eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
				//点击send message
				reamazePopupFrameObj.on("click","#content-container #footer>.anim-btn",function(){
					var name = $(this).attr("title");
					var gaData = {"eventCategory":"Popover_Livechat","eventAction":"Click","eventLabel":"Send a Message","eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
			}
			else
			{
				setTimeFunction(that.livechatPopupEvent)
			}
 		},
		// 订阅事件 -- 打开
		NewsletterOpenEvent:function(){
			var gaData = {"eventCategory":"Popover_Subscription","eventAction":"View","eventLabel":"Popover_Subscription","eventNoninteraction":"1"}
			this.dataLayerPush(gaData);
		},
		// 订阅事件 自动打开事件
		NewsletterAutoOpenEvent:function(){
			var title = "Auto_Subscription"
			var gaData = {"eventCategory":"Auto_Subscription","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
			this.dataLayerPush(gaData);
		},
		// 订阅弹框事件
		NewsletterPopupEvent:function(){
			var NewsletterPopup = configData.NewsletterPopup;
			var NewsletterPopupForm = $("#NewsletterPopup-form");
			var iframeForm = ".spinSubscribeForm";
			var spinSource = "#spin_source";
			
			// 关闭
			NewsletterPopupForm.find(".modal__close").click(function(){
				var title = "Popover_Subscription-"+getSpinSource();
				var gaData = {"eventCategory":"Popover_Subscription","eventAction":"Close","eventLabel":"Popover_Subscription","eventNoninteraction":"0"}
				NewsletterPopup.find(spinSource).val("")
				that.dataLayerPush(gaData);
			})
			
			//获取来源
			function getSpinSource()
			{
				var spin_source_val = NewsletterPopup.find(spinSource).val();
				!spin_source_val == (spin_source_val = "auto")
				return spin_source_val;
			}
			
			NewsletterPopupForm.submit(function(){
				var gaData = {"eventCategory":"Popover_Subscription","eventAction":"Submit","eventLabel":"CLAIM MY OFF","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 拒绝订阅  已无
			NewsletterPopupForm.find(".text-close").click(function(){
				var gaData = {"eventCategory":"Popover_Subscription","eventAction":"Click","eventLabel":"Decline Offer","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		// 订阅弹框 引导注册
		NewsletterPopupSignUpEvent:function(){
			var NewsletterPopup = configData.NewsletterPopup;
			var NewsletterPopupForm = $("#NewsletterPopup-form");
			
			var title = "Popover_SignUpGuide"
			var gaData = {"eventCategory":"Popover_SignUpGuide","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
			this.dataLayerPush(gaData);
          
			// 关闭
			NewsletterPopupForm.find(".modal__close").click(function(){
				var title = "Popover_SignUpGuide";
				var gaData = {"eventCategory":"Popover_SignUpGuide","eventAction":"Close","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// sign up
			NewsletterPopupForm.find(".success_from_btn").click(function(){
				var title = "SIGN UP FOR 500 POINTS (=$5)";
				var gaData = {"eventCategory":"Popover_SignUpGuide","eventAction":"Close","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 关闭
			NewsletterPopupForm.find(".prompt-messages").click(function(){
				var title = "START SHOPPING";
				var gaData = {"eventCategory":"Popover_SignUpGuide","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
        // 订阅转盘 -- 打开  2022-10-14
        SpinOpenEvent:function(){
			var gaData = {"eventCategory":"Popover_Spin","eventAction":"View","eventLabel":"Popover_Spin","eventNoninteraction":"1"}
			this.dataLayerPush(gaData);
		},
		// 订阅转盘 -- 引导订阅  2022-10-14
        SpinSubscriptionEvent:function(){
			var gaData = {"eventCategory":"Popover_Spin","eventAction":"Click","eventLabel":"Popover_Spin_Subscription","eventNoninteraction":"0"}
			this.dataLayerPush(gaData);
		},
		// 订阅转盘 -- 关闭   2022-10-14
        SpinClostEvent:function(){
			var gaData = {"eventCategory":"Popover_Spin","eventAction":"Click","eventLabel":"Popover_Spin_Close","eventNoninteraction":"0"}
			this.dataLayerPush(gaData);
		},
        // 用户召回弹窗事件 -- 打开
		RecallPopupOpenEvent:function(){
			var gaData = {"eventCategory":"Popover_Recall","eventAction":"View","eventLabel":"Popover_Recall","eventNoninteraction":"1"}
			this.dataLayerPush(gaData);
		},
        // 用户召回弹窗事件 引导订阅
		RecallPopupSubscriptionEvent:function(){
			var gaData = {"eventCategory":"Popover_Recall_Subscription","eventAction":"Click","eventLabel":"Popover_Recall_Subscription","eventNoninteraction":"1"}
			this.dataLayerPush(gaData);
        },
      	// 首页 Comfort, Simplicity And Self-Love
		ComfortSimplicityAndSelfLoveEvent:function(){
			var box = $(".story-one-box");
			var btn = box.find(".right-box .button")
			
			btn.click(function(){
				var title = "Comfort, Simplicity And Self-Love_LEARN MORE";
				var gaData = {"eventCategory":"HomePage","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		//logo	点击事件
		topLogoEvent:function(){
			var logoObj = $(".header-wrapper .site-header__logo")
			logoObj.click(function(){
				var gaData = {"eventCategory":"Header","eventAction":"Click","eventLabel":"Logo","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		// 菜单事件
		menuEvent:function(){
			var mainMenuBox = $(".site-navigation");
			var mainMenuItem = ".site-nav__item";
			var mainMenuItemA = ".site-nav__link";
			var mainMenuSecondItemA = ".site-nav__dropdown .nav-two .h5 a";
			var mainMenuThirdItemA = ".nav-three-box .h5-info-btn a";
			// 一级	
			mainMenuBox.find(mainMenuItemA).click(function(){
				var menuTitle = getDomText($(this));
				if(!menuTitle)
					menuTitle = getDomText($(this).find(".silder-text"));
				var gaData = {"eventCategory":"Menu L1","eventAction":"Click","eventLabel":"L1::"+menuTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 二级
			mainMenuBox.find(mainMenuSecondItemA).click(function(){
                
				var menuTitle = getDomText($(this).parents(mainMenuItem).find(mainMenuItemA));
				if(!menuTitle)
					menuTitle = getDomText($(this).parents(mainMenuItem).find(mainMenuItemA).find("span").eq(0));
				var nowTitle = getDomText($(this));
				if(!nowTitle)
					nowTitle = getDomText($(this).find(".site-nav__dropdown-link"));
				var label = "L1::"+menuTitle+"_L2::"+nowTitle
				var gaData = {"eventCategory":"Menu L2","eventAction":"Click","eventLabel":label,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 三级
			mainMenuBox.find(mainMenuThirdItemA).click(function(){
                
				var menuSecondTitle = getDomText($(this).parents(".nav-three-text-box").find(".nav-three-h5 .site-nav__dropdown-link"));
				
				var menuTitle = getDomText($(this).parents(mainMenuItem).find(mainMenuItemA));
				if(!menuTitle)
					menuTitle = getDomText($(this).parents(mainMenuItem).find(mainMenuItemA).find("span").eq(0));
					
				var nowTitle = getDomText($(this));
				if(!nowTitle)
					nowTitle = getDomText($(this).find(".site-nav__dropdown-link"));
				var label = "L1::"+menuTitle+"_L2::"+menuSecondTitle+"_L3::"+nowTitle
				var gaData = {"eventCategory":"Menu L3","eventAction":"Click","eventLabel":label,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		menupopUpEvent:function(){
			var mainMenuBox = $(".mobile-nav");
			var mainMenuItem = ".mobile-nav__item.appear-animation ";
			var mainMenuItemA = ".mobile-nav__link--top-level";
			var mainMenuSecondItemA = ".mobile-nav__sublist .mobile-nav__link";
			
			var menuOpenBtn = $(".site-nav button.js-drawer-open-nav");
			var menuCloseBtn = $("#NavDrawer .close.search-image");
						
			// 加载弹框
			menuOpenBtn.click(function(event){
				if(typeof event.originalEvent == "undefined")
   					return false
				var title = "MenuPopUp_View"
				var gaData = {"eventCategory":"MenuPopUp","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
				that.dataLayerPush(gaData);	
			})
			// 关闭弹框
			menuCloseBtn.click(function(){
				var title = "MenuPopUp_Close"
				var gaData = {"eventCategory":"MenuPopUp","eventAction":"Close","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);	
			})
			// 促销点击
			$("#NavDrawer .mobile-nav__item .silder-banner").click(function(){
				var title = "MenuPopUp_Promotion_10%OFF"
				var gaData = {"eventCategory":"MenuPopUp","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);		
			}) 
			// 底部注册登录数据点击 底部推荐数据点击
			$("#NavDrawer .mobile-nav__item .grid__item a").click(function(){
				var title = getDomText($(this));
				!title && (title = getDomText($(this).find("button")))
				var gaData = {"eventCategory":"MenuPopUp","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);		
			})
			// 底部国家数据点击
			$("#NavDrawer .mobile-nav__item .grid__item.silder-currency .mobile-nav__link").click(function(){
				var title = "Silder Currency"
				var gaData = {"eventCategory":"MenuPopUp","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);		
			})
			
			// 一级	
			mainMenuBox.find(mainMenuItemA).click(function(){
				var menuTitle = getDomText($(this));
				if(!menuTitle)
					menuTitle = getDomText($(this).find(".silder-text"));
				var gaData = {"eventCategory":"MenuPopUp","eventAction":"Click","eventLabel":"L1::"+menuTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 二级
			mainMenuBox.find(mainMenuSecondItemA).click(function(){
                
				var menuTitle = getDomText($(this).parents(mainMenuItem).find(mainMenuItemA));
				if(!menuTitle)
					menuTitle = getDomText($(this).parents(mainMenuItem).find(mainMenuItemA).find(".silder-text"));
				var nowTitle = getDomText($(this));
				if(!nowTitle)
					nowTitle = getDomText($(this).find(".site-nav__dropdown-link"));
				var label = "L1::"+menuTitle+"_L2::"+nowTitle
				var gaData = {"eventCategory":"Menu L2","eventAction":"Click","eventLabel":label,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
      	//头部 按钮事件
		headButtonEvent:function(){
			
			var headBox = $(".header-layout");
			var headIconBox = ".site-header";
			var headIconItem = ".site-nav__link";
			var gaDataBase = {"eventCategory":"Header","eventAction":"Click","eventLabel":"","eventNoninteraction":"0"}
			// 币种
			$(".announcement-bar").on("click",".state",function(event){
              
				//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
				
				var gaData = gaDataBase;
				gaData["eventLabel"] = "Currency"
				that.dataLayerPush(gaData);
			})
			// 通用的按钮
			headBox.find(headIconItem).click(function(event){
              
				//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
					
				var gaData = gaDataBase;
				var title = $(this).attr("data-ga-title")
				gaData["eventLabel"] = title
				that.dataLayerPush(gaData);
			})
		},
		// 国家或货币选择
		headCountryCurrency:function(){
			var box = $("#right-country");
			var openBtn = ".state";
			var closeBtn = ".country-currency-box-close";
			var countryItem = ".country-box .custom-select-list .custom-select-item ";
			var currencyItem = ".currency-box .custom-select-list .custom-select-item ";
			
			
			var gaDataBase = {"eventCategory":"Popover_Store","eventAction":"Click","eventLabel":"","eventNoninteraction":"0"}
			// 币种弹框加载
			$(".announcement-bar").on("click",openBtn,function(event){
				//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
				
				var gaData = gaDataBase;
				gaData["eventLabel"] = "Popover_Store"
				gaData["eventAction"] = "View"
				that.dataLayerPush(gaData);
			})
			// 币种弹框关闭
			box.on("click",closeBtn,function(event){
              	//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
                    
				var gaData = gaDataBase;
				gaData["eventLabel"] = "Popover_Store"
				gaData["eventAction"] = "Close"
				that.dataLayerPush(gaData);
			})
			// 国家选择
			box.on("click",countryItem,function(event){
              	//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
                    
				var gaData = gaDataBase;
				var title = getDomText($(this).find("a span"));
				gaData["eventLabel"] = "Store::"+title
				gaData["eventAction"] = "Select"
				that.dataLayerPush(gaData);
			})
			// 币种选择
			box.on("click",currencyItem,function(event){
              	//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
				var gaData = gaDataBase;
				var title = getDomText($(this).find(".currency-item-content span").eq(0));
				gaData["eventLabel"] = "Currency::"+title
				gaData["eventAction"] = "Select"
				that.dataLayerPush(gaData);
			})
			
		},
      	// 头部搜索
		searchPopupEvent:function(){
			
			var searchPopupBox = $("#search-box");
			var searchOpenBtn = $(".silder-search");
			var searchPopupCloseBtn = searchPopupBox.find(".search_close_close");
			var sumbitBtn = searchPopupBox.find(".site-header__search-btn--submit");
			var searchForm = searchPopupBox.find("#HeaderSearchForm");
			var recommendSearchItem = searchPopupBox.find(".trending-search p span");
			var recommendSearchUrlItem = searchPopupBox.find(".trending-search p a");
			// 打开search
			searchOpenBtn.click(function(event){
				
				//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
				
				var gaData = {"eventCategory":"Popover_Search","eventAction":"View","eventLabel":"Popover_Search","eventNoninteraction":"1"}
				that.dataLayerPush(gaData);
			})
			// 关闭 search
			searchPopupCloseBtn.click(function(event){
				
				//判断是否是自动触发 还是手动点击  自动触发
				if(typeof event.originalEvent == "undefined")
    				return false
					
				var gaData = {"eventCategory":"Popover_Search","eventAction":"Close","eventLabel":"Popover_Search","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 提交搜索
			searchForm.submit(function(){
				var q = $(this).find("input[name='q']").val();
				var gaData = {"eventCategory":"Popover_Search","eventAction":"Enter Search","eventLabel":q,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 点击热门搜索
			recommendSearchItem.click(function(){
				var nowTitle = getDomText($(this));
				var gaData = {"eventCategory":"Popover_Search","eventAction":"Popular Search","eventLabel":nowTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			/*
			// 点击直接跳转的文案 可与上面的通用 
			recommendSearchUrlItem.click(function(){
				var nowTitle = getDomText($(this).find("span"));
				var gaData = {"eventCategory":"Popover_Search","eventAction":"Popular Search","eventLabel":nowTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);	
			})
			*/
			
		},
      	// 头部用户按钮
		headAccount:function(){
			var accountBtn = $(".account-navs-box")
			var accountListBtn = ".account-navs a p";
			var customer = gaDataDeployConfigBase.customer;
			var eventCategory = customer ? "Popover_Account_LoggedIn" : "Popover_Account_NotLoggedIn"
			
			$(".account-navs-box").hover(function(){
				var gaData = {"eventCategory":eventCategory,"eventAction":"View","eventLabel":eventCategory,"eventNoninteraction":"1"}
				that.dataLayerPush(gaData);
			},function(){})
			
			// 列表元素点击
			accountBtn.on("click",accountListBtn,function(){
				var nowTitle = getDomText($(this));
				var gaData = {"eventCategory":eventCategory,"eventAction":"Click","eventLabel":nowTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
      	// minicart
		miniCartEvent:function(){
			var popup = $("#CartDrawer");
			var openBtn = $(".js-drawer-open-cart");
			var popupCloseBtn = popup.find(".js-drawer-close");
			var sumbitBtn = popup.find(".cart__checkout");
			var form = popup.find(".drawer__contents");
			var emptyCart = ".cart_catalog";
			var emptyCartMenu = ".cart_catalog a";
			// 打开 popup
			openBtn.click(function(){
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"View","eventLabel":"Popover_Mini Cart","eventNoninteraction":"1"}
				that.dataLayerPush(gaData);
			})
			// 关闭  popup
			popupCloseBtn.click(function(){
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"Close","eventLabel":"Popover_Mini Cart","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 空购物车 菜单点击事件
			popup.on("click",emptyCartMenu,function(){
				var title = getDomText($(this).find(".catalog"));
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// Add Order Note/Gift Note 点击事件
			popup.on("click",".cart-note>.input ",function(){
				var title = "Add Order Note/Gift Note";
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 修改订单留言 点击事件
			popup.on("click",".cart-note>.edit-text ",function(){
				var title = "Edit Order Note";
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 提交订单留言 点击事件
			popup.on("click",".cart-note>.textarea-box .save-note-button ",function(){
				var title = "Submit Order Note";
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
            // apply discount 事件
			// 点击事件
			function scDiscountApplyClickEvent()
			{
				if(popup.find(".scDiscount__container form #submit").length > 0)
				{
					popup.find(".scDiscount__container form #submit").click(function(){
						var discountVal =  getScDiscount();
						//console.log("点击事件",discountVal)
						var gaData = {"eventCategory":"minicartUseCoupon_all","eventAction":"Submit","eventLabel":discountVal,"eventNoninteraction":"0"}
						that.dataLayerPush(gaData);
						scDiscountDelete()
					})
					scDiscountDelete(1);
				}
				else
				{
					setTimeFunction(scDiscountApplyClickEvent)
				}
			}
			scDiscountApplyClickEvent();
			
			// 点击删除事件
			function scDiscountDelete(first)
			{
				if(popup.find(".scDiscount__container .sc_simple-info .code .button").length > 0)
				{
					popup.find(".scDiscount__container .sc_simple-info .code .button").click(function(){
						var discountVal =  $(this).parent().find(".code-name").attr("title")
						//console.log("点击删除事件",discountVal)
						var gaData = {"eventCategory":"minicartUseCoupon_all","eventAction":"Delete","eventLabel":discountVal,"eventNoninteraction":"0"}
						that.dataLayerPush(gaData);
					})
				}
				else
				{
					if(first)
					{
						var discountVal =  getScDiscount()
						if(discountVal)
							setTimeFunction(scDiscountDelete)	
					}
					else
						setTimeFunction(scDiscountDelete)	
				}
			}
			
			// discount 内容改变事件
			popup.on("change",".scDiscount__container form #code",function(){
				var discountVal =  getScDiscount()
				//console.log("内容改变事件",discountVal)
				var gaData = {"eventCategory":"minicartUseCoupon_all","eventAction":"FillIn","eventLabel":discountVal,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			function getScDiscount()
			{
				var discountVal = popup.find(".scDiscount__container #code").val();
				return discountVal;
			}
			// apply discount end 事件
			
			
            // checkout  点击事件
			popup.on("click",".cart__checkout",function(){
				var title = "CHECK OUT";
				var gaData = {"eventCategory":"Popover_Mini Cart","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
      	// 底部导航栏
		footMenuEvent:function(){
			var box = $(".site-footer");
			var menuMainItem = ".footerListItem ";
			var menuMainTitle = ".footerTitle";
			var menuItem = ".footerItemContent .footerItem a";
			var termAndBox = ".footer-copyright-a";
			var footNewdsletterBox = ".footerSubscribeContent";
			var footNewdsletterFrom = "form.contact-form";
			var footNewdsletterSocialItem = ".footerFollContent .footerFollAppList .footerFollAppItem a";
          	var NewsletterPopup = configData.NewsletterPopup;
			var spinSource = "#spin_source";
          	var newsletterPopupErrorBtn = ".NewsletterPopupError a";
			
			var config = {
				showTop : "100",
				showAttr : "ga_show"
			};
	
			// 底部菜单展示
			function footMenuShow()
			{
				if(box.attr(config.showAttr))
					return false;
				if(gaDataDeploy.itemIsEyeShow(box,config.showTop))
				{
					box.attr(config.showAttr,true)
					var gaData = {"eventCategory":"Footer","eventAction":"View","eventLabel":"Footer","eventNoninteraction":"1"}
					that.dataLayerPush(gaData);
				}
			}
			footMenuShow()
			$(window).resize(function(){
				footMenuShow()
			})
			$(window).scroll(function(){
				footMenuShow()
			})
			// 菜单点击事件
			box.on("click",menuItem,function(){
				
				var title = getDomText($(this));
				var mainTitle = getDomText($(this).parents(menuMainItem).find(menuMainTitle))
				var gaTitle = "L1::"+mainTitle+"_L2::"+title
				var gaData = {"eventCategory":"Footer","eventAction":"Click","eventLabel":gaTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 底部菜单点击事件
			box.on("click",termAndBox+" a",function(){
				var title = getDomText($(this));
				var gaTitle = title
				var gaData = {"eventCategory":"Footer","eventAction":"Click","eventLabel":gaTitle,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			/*********************** 底部订阅事件 *******************************/
			// 订阅提交事件   没有了
			box.on("submit",footNewdsletterFrom,function(){
				var gaData = {"eventCategory":"Footer","eventAction":"Click","eventLabel":"SUBSCRIBE","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 订阅提交事件  2021-10-12
			box.on("click",".footer-newsletter .footer-newsletter-btn",function(){
              	NewsletterPopup.find(spinSource).val("Footer_Subscription");	
				var gaData = {"eventCategory":"Footer_Subscription","eventAction":"Click","eventLabel":"SUBSCRIBE","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 外部分享事件
			box.on("click",footNewdsletterSocialItem,function(){
				var title = getDomText($(this).find(".icon__fallback-text"));
				var gaData = {"eventCategory":"Footer","eventAction":"Social","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 点击邮箱事件
			box.on("click",".footerFollText a",function(){
				var title = "Email";
				var gaData = {"eventCategory":"Footer","eventAction":"Support Contact","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
            // 订阅错误点击事件
			box.on("click",newsletterPopupErrorBtn,function(){
				var title = getDomText($(this));
				var gaData = {"eventCategory":"Footer","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
      	// 登录页面
		loginEvent:function(){
			var loginBox = $(".login-box");
			var recoverPasswordBox = $("#RecoverPasswordForm");
			var loginForm = "form#customer_login";
			var forgotPasswordBtn = ".forgetpassword #RecoverPassword";
			var registerBtn = loginBox.find(".customer_info a");
          	var errorBox = ".errors ul li";
			
			var recoverPasswordFormBox = $("#RecoverPasswordForm");
			var recoverPasswordForm = "form";
			var recoverPasswordFormEmail = "#RecoverEmail";
			var recoverPasswordCancel = "#HideRecoverPasswordLink";
			
			/********* 登录 *****************/
			// 找回密码
			loginBox.on("click",forgotPasswordBtn,function(){
				var gaData = {"eventCategory":"LoginPage","eventAction":"Click","eventLabel":"Forgot Your Password","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			// 登录
			loginBox.on("submit",loginForm,function(){
				var gaData = {"eventCategory":"LoginPage","eventAction":"Sign In","eventLabel":"Sign In","eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 错误信息
			function postErrorData()
			{
				var title = ""
				$.each(loginBox.find(loginForm).find(errorBox),function(){
					title = title ? title + "/" + getDomText($(this)) : getDomText($(this));
				})
				if(title)
				{
                  	title = "Login Error::"+title
					var gaData = {"eventCategory":"LoginPage","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
					that.dataLayerPush(gaData);
				}
			}
			postErrorData()
			
			// 去注册
			registerBtn.click(function(){
				var title = getDomText($(this));
				!title && (title =  getDomText($(this).find("div")));
				var gaData = {"eventCategory":"LoginPage","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			/***************** 重置密码 ****************/
			recoverPasswordFormBox.on("submit",recoverPasswordForm,function(){
				var title = "Reset Password"
				var gaData = {"eventCategory":"LoginPage","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 取消
			recoverPasswordBox.on("click",recoverPasswordCancel,function(){
				var title = "Reset Password Cancel"
				var gaData = {"eventCategory":"LoginPage","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		// 注册页面
		registerEvent:function(){
			var registerBox = $(".register-box");
			var registerForm = "form#create_customer";
			var keepMe = "input[name='customer[accepts_marketing]']";
			var errorBox = ".errors ul li";
			var loginBtn = registerBox.find(".customer_info a");
			
			/********* 注册 *****************/
			// 登录页面 - 注册
			registerBox.on("submit",registerForm,function(){
				var keepMeStatus = registerBox.find(keepMe).is(":checked");
				var title = keepMeStatus ? "Creat Account With Subscription" : "Creat Account  Without Subscription"


				var gaData = {"eventCategory":"CreatAccountPage","eventAction":"Creat Account","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 去登录
			loginBtn.click(function(){
				var title = getDomText($(this));
				!title && (title =  getDomText($(this).find("div")));
				var gaData = {"eventCategory":"CreatAccountPage","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			// 错误信息
			function postErrorData()
			{
				var title = ""
				$.each(registerBox.find(registerForm).find(errorBox),function(){
					title = title ? title + "/" + getDomText($(this)) : getDomText($(this));
				})
				if(title)
				{
					title = "Creat Account Error::"+title
					var gaData = {"eventCategory":"CreatAccountPage","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
					that.dataLayerPush(gaData);
				}
			}
			postErrorData()
		},
      	// 分类页面
		collectionEvent:function(quickView){

			var box = $("#MainContent");
			var collectionItemList = ".collection-button-list ";
			var collectionItem = ".collection-button-item";
			
			var productItem = ".grid__item.grid-product"
			var productColorItem = ".grid-product__colors a"
			var productQuickView = ".quick-product__btn .quick-product__label"
			var productQuickViewCloseBtn = ".modal--quick-shop .modal__close"
          
            //筛选器
			var filterBtn = ".CollectionFilterTitleBtn";
			var filterType = ".CollectionFilterForm .facets__disclosure .facets__summary";
			var filterItem = ".CollectionFilterForm .facets__list .list-menu__item input[type='checkbox']";
			var filterItemClose = ".active-facets a";
          
			if(!quickView)
			{
				//分类切换点击事件
				box.on("click",collectionItemList + " " +collectionItem ,function(){
					var title = getDomText($(this));
					var gaData = {"eventCategory":"ProductListPage","eventAction":"Switch Product List","eventLabel":title,"eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})
				// quick view关闭事件
				box.on("click",productQuickViewCloseBtn,function(){
					var title = "ProductListPage_Popover_Product"
					gaData = {"eventCategory":"ProductListPage_Popover_Product","eventAction":"Close","eventLabel":title,"eventNoninteraction":"0"}
					that.dataLayerPush(gaData);		
					
				})
				
				// 属性点击事件
				// color
				box.on("click",productItem+" "+productColorItem,function(){
					var title = $(this).attr("data-value")
					var gaData = {"eventCategory":"ProductListPage","eventAction":"Select Color","eventLabel":title,"eventNoninteraction":"0"}
					that.dataLayerPush(gaData);
				})

                /*******************************  筛选器 ************************************************************************/
				// filter 筛选popover按钮点击
				box.on("click",filterBtn,function(){
					
					var title = "Filter";
					
					var status = $(this).parents(".CollectionFilter-template").attr("data-filter");
					var eventAction = status == "true" ? "View" : "Close";
					//console.log("filter 筛选popover按钮点击",eventAction);
					var gaData = {"eventCategory":"ProductListPage_Filter_Popove","eventAction":eventAction,"eventLabel":title,"eventNoninteraction":"0"}
					//console.log(gaData)
					that.dataLayerPush(gaData);
				})
				// filterType 按钮点击
				box.on("click",filterType,function(){
					
					var filterBox = $(this).parents(".js-filter");
					var filterText = filterBox.attr("data-type");
					var status = filterBox.attr("open");
					filterText = filterText ? filterText : getDomText(filterBox.find(".facets__summary div>span"))
					
					var title = "FL1::"+filterText;
					var eventAction = status ? "View" : "Close";
					//console.log("filterType 按钮点击",eventAction);
					var gaData = {"eventCategory":"ProductListPage_Filter_Popove_Type","eventAction":eventAction,"eventLabel":title,"eventNoninteraction":"0"}
					//console.log(gaData)
					that.dataLayerPush(gaData);
					
				})
				// filter item 按钮点击
				box.on("click",filterItem,function(){
					
					var itemBox = $(this).parents(".facets__item");
					var filterBox = $(this).parents(".js-filter");
					var itemText = getDomText(itemBox.find("label>span"));
					var filterText = filterBox.attr("data-type");
					var status = $(this).prop("checked");
					filterText = filterText ? filterText : getDomText(filterBox.find(".facets__summary div>span"))
					if(itemBox.find(".money").length > 0)
					{
						var moneyList = [];
						itemBox.find(".money").each(function(k,v){
							moneyList.push(getDomText($(this)))
						})
						itemText = moneyList.join("-");
					}
					
					var title = "FL1::"+filterText+"_FL2::"+itemText;
					var eventAction = status ? "Choose" : "Cancel";
					//console.log(" filter item 按钮点击",eventAction);
					var gaData = {"eventCategory":"ProductListPage_Filter_Popove_Item","eventAction":eventAction,"eventLabel":title,"eventNoninteraction":"0"}
					//console.log(gaData)
					that.dataLayerPush(gaData);
				})
				
				// filter item 取消选中
				$(".CollectionFilterHead").on("click",filterItemClose,function(){
					
					var itemText = $(this).attr("data-value");
					var filterText = $(this).attr("data-name");
					var itemType = $(this).attr("data-type");
					// 删除全部
					if(itemType == "removeAll")
					{
						var title = "removeAll";
						var eventAction =  "Cancel";
						
						//console.log(" filter item 取消选中",eventAction);
						var gaData = {"eventCategory":"ProductListPage_Filter_Popove_Item","eventAction":eventAction,"eventLabel":title,"eventNoninteraction":"0"}
						//console.log(gaData)
						that.dataLayerPush(gaData);
						return 
					}
					if($(this).find(".money").length > 0)
					{
						var moneyList = [];
						$(this).find(".money").each(function(k,v){
							moneyList.push(getDomText($(this)))
						})
						itemText = moneyList.join("-");
						filterText = "price";
					}	
					
					var filterTextList = filterText.split(".");
					filterText = filterTextList[filterTextList.length -1 ];
					
					var title = "FL1::"+filterText+"_FL2::"+itemText;
					var eventAction =  "Cancel";
					
					//console.log(" filter item 取消选中",eventAction);
					var gaData = {"eventCategory":"ProductListPage_Filter_Popove_Item","eventAction":eventAction,"eventLabel":title,"eventNoninteraction":"0"}
					//console.log(gaData)
					that.dataLayerPush(gaData);
				})

			}
			else
			{
				// quick view 点击事件
				function productQuickViewOpen()
				{
					var productTitle = quickView.parents(productItem).find(".grid-product__title").text();
					var title = productTitle + "_Quick View"
					var gaData = {"eventCategory":"ProductListPage_Popover_Product","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
					that.dataLayerPush(gaData);		
					
					setTimeout(function(){
						if($(".modal--quick-shop.modal--is-active").length > 0)
						{
							title = productTitle;
							title = "Product::"+title
							gaData = {"eventCategory":"ProductListPage_Popover_Product","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
							that.dataLayerPush(gaData);		
						}
						
					},600)		
				}
				productQuickViewOpen()
			}
		},
		// 产品详情页面 quick view 点击事件
		productDetailEvent:function(box){
			
			var eventCategory = "ProductListPage_Popover_Product";
			var quickViewBox = box;
			if(!box)
			{
				var box = $(".product-section:not(.is-modal)");
				eventCategory = "ProductDetailPage";
			}
			
			var productForm = "form.product-single__form";
			var productVariantItem = ".variant-wrapper";
			var productVariantAttrItem = ".variant-input";
			var productVariantAttrItemBtn = ".variant__button-label"
			var productVariantAttrItemInput = "input[type='radio']"
			var productQtyMinusBtn = ".js-qty__wrapper .js-qty__adjust--minus";
			var productQtyPlusBtn = ".js-qty__wrapper .js-qty__adjust--plus";
			var sizeGuide = ".size_click";
			var addcheckbox = ".addcheckbox";
			var customBtn = ".custom_pajamas .custom_pajamas_check";
			var customBtnClose = "#pajamas-customsize .modal__close"
			var productName = $.trim(box.find(".product-single__meta .product-single__title").text());
			var socialItem = ".social-sharing .social-sharing__link";
			
			var reivewBox = $("#judgeme_product_reviews");
			var reivewForm = ".jdgm-form";
			var reivewFormSubmit = ".jdgm-submit-rev ";
			var reivewFormCancel = ".jdgm-cancel-rev";
			var reivewFormSort = ".jdgm-sort-dropdown";
			
			var bindName = "product-ga-othen-bind";
			// 判断是否已经绑定事件
			if(box.attr(bindName))
				return false;
			box.attr(bindName,true)
			
			//属性选择
			box.on("click",productForm+" "+productVariantItem+" "+productVariantAttrItemBtn,function(){
				var attrItem = $(this).parents(productVariantAttrItem).find(productVariantAttrItemInput)
				var title = attrItem.attr("value")
				var attrName = attrItem.attr("name")
				var actionTitle = "Select "+attrName
				var gaData = {"eventCategory":eventCategory,"eventAction":actionTitle,"eventLabel":title,"eventNoninteraction":"0"}

				that.dataLayerPush(gaData,quickViewBox);
			})
			// 数量点击
			box.on("click",productQtyMinusBtn,function(){
				productQtyChange("minus");
			})
			box.on("click",productQtyPlusBtn,function(){
				productQtyChange("plus");
			})
			function productQtyChange(type)
			{
				var actionTitle = "Quantity Plus"
				type == "minus" && (eventAction = "Quantity Minus") 
				var title = "Product::"+productName
				var gaData = {"eventCategory":eventCategory,"eventAction":actionTitle,"eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			}
			
			//sizeGuide
			box.on("click",productForm+" "+sizeGuide,function(){
				var gaData = {"eventCategory":eventCategory,"eventAction":"Open","eventLabel":"SIZE GUIDE","eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
			// 礼品盒
			box.on("click",addcheckbox,function(){
				var thataa = this
				setTimeout(function(){
					var isSelected = $(thataa).hasClass("addcheckboxtrue");
					var eventAction = "Choose";
					!isSelected && (eventAction = "Cancel");
					var gaData = {"eventCategory":eventCategory,"eventAction":eventAction,"eventLabel":"Gift Wrapping","eventNoninteraction":"0"}
					that.dataLayerPush(gaData,quickViewBox);
				},100)				
			})
			// 定制
			box.on("click",customBtn,function(){
				var title = "Request Size Customization";
				var gaData = {"eventCategory":eventCategory,"eventAction":"Choose","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
			box.on("click",customBtnClose,function(){
				var title = "Request Size Customization";
				var gaData = {"eventCategory":eventCategory,"eventAction":"Cancel","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
			
			//分享
			box.on("click",socialItem,function(){
				var title = $(this).attr("title");
				var gaData = {"eventCategory":eventCategory,"eventAction":"Share","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
			
			// 评论 
			reivewBox.on("click",reivewFormCancel,function(){
				var title = $(this).val();
				var gaData = {"eventCategory":eventCategory,"eventAction":"Review","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
			reivewBox.on("click",reivewFormSubmit,function(){
				var title = $(this).val();
				var gaData = {"eventCategory":eventCategory,"eventAction":"Review","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
			reivewBox.on("change",reivewFormSort,function(){
				var title = $(this).val();
				var gaData = {"eventCategory":eventCategory,"eventAction":"Switch Tab","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData,quickViewBox);
			})
		},
		// 用户中心页面
		customerCenterEvent:function(){
			// 左侧菜单点击事件
			$(".side-navigation .side-nav a").click(function(){
				var title =  getDomText($(this).find(".underline"));
				var gaData = {"eventCategory":"AccountPage_Leftbar","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			// Account Information
			// 修改生日
			$(".profileinfo").on("click",".profilecontent .birthday .button",function(){
				var title =  getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Account Information","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 重置密码
			$(".profileinfo").on("click",".change-password #recover_customer_password .Form__Submit,.change-password #recover_customer_password #customer_logout_link .quit",function(){
				var title =  getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Account Information","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			// Address Book
			//点击ADD NEW ADDRESS
			var addressesPopupBox = $("#AddressNewmodal");
			var addressPageBox = $(".addresses-box");
			addressPageBox.on("click",".address-new-toggle",function(){	
              	if($(this).hasClass("addresses_cancel_new"))
                  return false;
				var title = getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Address Book","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
				
				// 弹框加载事件
				setTimeout(function(){
					if(addressesPopupBox.hasClass("modal--is-active"))
					{
						var title = "ADD  ADDRESS_Popup";
						var gaData = {"eventCategory":"AccountPage_Address Book","eventAction":"View","eventLabel":title,"eventNoninteraction":"1"}
						that.dataLayerPush(gaData);
					}					
				},200)
			})
			
			// 地址列表按钮点击
			addressPageBox.on("click",".addresses-content-box .one button[data-form-id]",function(){				
				var title = getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Address Book","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
				
			})
			// 弹框表单按钮点击事件
			addressesPopupBox.on("click","#address_form_new .btn-box button",function(){
				var title = getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Address Book","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			// 弹框关闭事件
			addressesPopupBox.on("click",".address_div_close",function(){
				var title =  "ADD  ADDRESS_Popup";
				var gaData = {"eventCategory":"AccountPage_Address Book","eventAction":"Close","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
            
            // orders
			var orderBox = $(".Container");
			// 没有订单的情况下 点击 shop now
			orderBox.on("click",".noorder .Segment__ButtonWrapper a",function(){
				var title =  getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Orders","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 有订单的情况下 点击 查看订单详情
			orderBox.on("click",".PageLayout .AccountTable tr td a",function(){
				var title = "Orders_"+getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Orders","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
            /*************************** return  **************************************/
			var returnBox = $(".returns-box");
			// 点击 REQUEST NEW RETURN
			returnBox.on("click","a .returns-btn",function(){
				var title = getDomText($(this));
				var gaData = {"eventCategory":"AccountPage_Returns","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			/*************************** Rewards  **************************************/
			var rewardsBox = $(".rewards-box");
			// Redeem Points
			rewardsBox.on("click",".redeem-points .redeem-points-box .item-lump-default .discounts-btn",function(){
				var defaultBox = $(this).parents(".item-lump-default");
				if(defaultBox.hasClass("item-lump-disabled"))
					return false;
					
				var title = getDomText(defaultBox.find(".discounts-box"));
				title = "Redeem Points_"+title+"_Redeem"
				var gaData = {"eventCategory":"AccountPage_Rewards","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// Earn More Points
			rewardsBox.on("click",".gain-points .gain-points-box .item-lump-default .gain-points-btn",function(){
				var defaultBox = $(this).parents(".gain-points-box ");
				if(defaultBox.attr("data-is-used") == "true")
					return false;
					
				var title = getDomText(defaultBox.find(".gain-points-condition"));
				title = "Earn More Points_"+title+"_Redeem"				
				var gaData = {"eventCategory":"AccountPage_Rewards","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			// Refer Your Friends
			// Copy Link
			rewardsBox.on("click",".interlinkage .interlinkage-left-box-container .link-container .link-box .link-icon-content.copyLinks ",function(){
				var title = "Copy Link"			
				var gaData = {"eventCategory":"AccountPage_Rewards","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			// 分享
			rewardsBox.on("click",".interlinkage .interlinkage-left-box-container .link-container .link-box .link-icon-content1 .link-icon img ",function(){
				var title = $(this).attr("alt");		
				var gaData = {"eventCategory":"AccountPage_Rewards","eventAction":"Share","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			
			/******************************  My VIP Status  ****************************************/
			var statusVipBox = $(".Status-vip-box");
			// 
			statusVipBox.on("click",".membership .code-button",function(){
				var title = getDomText($(this));		
				var gaData = {"eventCategory":"AccountPage_VIP Status","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
			statusVipBox.on("click",".membership .link",function(){
				var title = "Link::"+getDomText($(this));		
				var gaData = {"eventCategory":"AccountPage_VIP Status","eventAction":"Click","eventLabel":title,"eventNoninteraction":"0"}
				that.dataLayerPush(gaData);
			})
		},
		
		ready:function(){
			that = this;
		},
		init:function(){
			this.ready();
			// 
			
			//积分插件
			this.rewardEvent();
			// 聊天插件
			this.livechatEvent();
			// 订阅弹框
			this.NewsletterPopupEvent();
          	// 首页 Comfort, Simplicity And Self-Love
			if(gaDataDeploy.config.pageType == "index")		
				this.ComfortSimplicityAndSelfLoveEvent(); 	
			//logo	点击事件
			this.topLogoEvent()
			// 菜单事件
			this.menuEvent()
            // 菜单弹出层事件 
			this.menupopUpEvent()
            // head button
			this.headButtonEvent();
			// 国家或货币选择
			this.headCountryCurrency();
			// 头部搜索
			this.searchPopupEvent();
          	// 头部用户按钮
			this.headAccount();
          	// minicart
			this.miniCartEvent();
          	// 底部导航栏
			this.footMenuEvent();
          	// 登录页面
			if(gaDataDeploy.config.pageType == "customers/login")
				this.loginEvent();
			// 注册页面
			if(gaDataDeploy.config.pageType == "customers/register")	
				this.registerEvent();
			// 分类页面
			if(gaDataDeploy.config.pageType == "collection")	
				this.collectionEvent();
            // 产品页面
            if(gaDataDeploy.config.pageType == "product")	
				this.productDetailEvent(); 	
          	// 用户中心页面
           	this.customerCenterEvent(); 
			
		},
                                 
		dataLayerPush:function(gaData,quickViewBox){
			!gaData["event"] && (gaData["event"] = "uaevent");
			gaDataDeploy.publicDeploy().dataLayerPush(gaData,quickViewBox);
		}
		
	})
	if(!noInit)
		elementClick.init();
	else
		elementClick.ready()	
	return elementClick ;
},







//ga 埋点 公共传输方法
gaDataDeploy.publicDeploy  = function()
{
	var config = {
		currency: "",	
		loginStatus:"no"
	}
	
	function publicDeploy()
	{
		/* 切换币种
		var currency = $(".currency-switcher").val();
		if(!currency)
			currency = gaDataDeploy.config.currency
		config.currency = currency;
		*/
		config.currency = gaDataDeploy.config.currency
		config.loginStatus = gaDataDeploy.config.customer == "" ? "no" : "yes"
	}
	
	var publicDeploy = new publicDeploy();
	publicDeploy = Object.assign({},publicDeploy,{
		// 产品展示ga数据传输
		productEyeShow:function(data){
			var pushData = {
				'event':'uaevent',
				'eventNoninteraction': true,
				'eventCategory':'Ecommerce',
				'eventAction':'Product Impressions',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'currencyCode': config.currency,                    
					'impressions': data["products"]
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		// 产品点击ga数据传输
		productClick:function(data){
			var pushData = {
				'event':'productClick',
				'eventCategory':'Ecommerce',
				'eventAction':'Product Click',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'click': {
						'actionField': data["actionField"],    //  产品所在的列表名称,   
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		//产品详情展示事件 ga数据传输
		productDetail:function(data){
			var pushData = {
				'event':'uaevent',
				'eventNoninteraction': true,
				'eventCategory':'Ecommerce',
				'eventAction':'Product Detail',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'detail': {                               
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		// 产品加购ga数据传输
		productAddCart:function(data,listName){
			var pushData = {
				'event': 'addToCart',
				'eventCategory':'Ecommerce',
				'eventAction':'Add to Cart',
                'addToCartListName':listName ? listName : "",
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'currencyCode': config.currency, 
					'add': {                               
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		// 产品减购或删除ga数据传输
		productReomveCart:function(data){
			var pushData = {
				'event': 'removeFromCart',                                                       
				'eventCategory':'Ecommerce',
				'eventAction':'Remove from Cart',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'currencyCode': config.currency, 
					'remove': {                               
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		// checkout ga数据传输  
		checkoutStep01:function(data){
			var pushData = {
				'event':'checkout',
				'eventCategory':'Ecommerce',
				'eventAction':'Checkout',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'checkout': {
						'actionField': {'step': 1,'option':'Go To Cart', 'loginStatus':config.loginStatus},
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		checkoutStep02:function(data){
			var isLogin = gaDataDeploy.config.customer == "" ? "no" : "yes"
			var pushData = {
				'event':'checkout',
				'eventCategory':'Ecommerce',
				'eventAction':'Checkout',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'checkout': {
						'actionField': {'step': 2, 'option': 'Go To Checkout','loginStatus':config.loginStatus},
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		checkoutStep03:function(data){
			var isLogin = gaDataDeploy.config.customer == "" ? "no" : "yes"
			var pushData = {
				'event':'checkout',
				'eventCategory':'Ecommerce',
				'eventAction':'Checkout',
				'userId':gaDataDeploy.config.customer,
				'ecommerce': {
					'checkout': {
						'actionField': {'step': 3,'option':'paypal', 'loginStatus':isLogin},
						'products': data["products"]
					}
				}
			};
			pushData = $.extend(pushData, data["detail"]);
			this.dataLayerPush(pushData);
		},
		// 促销事件
		promotion:function(data){
			var pushData = {
				"event":"uaevent",
				"eventNoninteraction": true,
				"eventCategory":"Ecommerce",
				"eventAction":"Promotion Impressions",
				"userId":gaDataDeploy.config.customer,
				"ecommerce": {
					'promoView': {
						'promotions': data["items"]
					}
				}
			};			
			this.dataLayerPush(pushData);
		},
        // 促销点击事件
		promotionClick:function(data){
			var pushData = {
				'event':'promotionClick',
				'eventCategory':'Ecommerce',
				'eventAction':'Promotion Click',
				'event': 'promotionClick',
				"userId":gaDataDeploy.config.customer,
				'ecommerce': {
					'promoClick': {
						'promotions': data["items"]
					}
				}
			};			
			this.dataLayerPush(pushData);
		},
		// push 公共参数
		pushCommnet:function(quickViewBox){
			var our_cookie_name = "ONE_OF_US";
			
			var gaDataDetail = [];
			gaDataDetail["productId"] = "";
			gaDataDetail["pcat"] = "";
			gaDataDetail["ecomm_proid"] = "";
			gaDataDetail["PageGroup1"] = "";
			gaDataDetail["PageGroup2"] = "";
			gaDataDetail["PageGroup3"] = "";
			gaDataDetail["one_of_us"] = getCookieValue(our_cookie_name);			
			
			if(quickViewBox)
			{
				//console.log("quickViewBox 条件触发")
				var itemObj = quickViewBox;
				var gaDataDetailNew = getProductData(itemObj);
				
				gaDataDetail = Object.assign(gaDataDetail,gaDataDetailNew);
			}
			else if(gaDataDeploy.config.pageType == "product")
			{
				var itemObj = $("div.product-section[data-product-data]:not(.is-modal)");
				var gaDataDetailNew = getProductData(itemObj);
				
				gaDataDetail = Object.assign(gaDataDetail,gaDataDetailNew);
			}
			
			/***************** 获取数据方法 *******************************/
			// 获取产品块的数据
			function getProductData(itemObj)
			{
				var productData = itemObj.attr("data-product-data");
				if(!productData)
					return false;
				productData = JSON.parse(productData);
				
				var gaDataDetail = [];
				gaDataDetail["productId"] = productData["spu"];
				gaDataDetail["pcat"] = productData["pcat"];
				gaDataDetail["ecomm_proid"] = productData["spu"];
				gaDataDetail["PageGroup3"] = productData["pcat"];
				return gaDataDetail;
			}
			
			/* 判断自己人 */
			function getCookieValue(coockiename)
			{
				try{
					var name = coockiename + "=";
					var ca = document.cookie.split(';');
					for(var i=0; i<ca.length; i++)
					{
						var c = ca[i].trim();
						if (c.indexOf(name)==0)
						{
							return c.substring(name.length,c.length);
						}
					}
				}
				catch(e){}
				return "unknow";
			}
			/***************** 获取数据方法end *******************************/
			
			return gaDataDetail;
		},
		
		dataLayerPush:function(pushData,quickViewBox){
			var pushCommnet = this.pushCommnet(quickViewBox);
			pushData = $.extend(pushData, pushCommnet);
			pushData["userId"] = pushData["userId"] ? pushData["userId"] : gaDataDeploy.config.customer;
 			//console.log("pushData",pushData)
			dataLayer.push(pushData);
			
		}
	});
	return publicDeploy;
}


$(function(){
  gaDataDeploy.init();
})



$(function(){

/************************************ 站内促销监控 **********************************************/	
	
	/***********************************  首页 *****************************************/	
	//首页 推荐分类埋点
  	function homeRecommendCatalog()
  	{
		var classType = "homeRecommendCatalog";
		if(typeof(gaDataDeploy) == "object" && gaDataDeploy.config[classType].box.length > 0)
		{
			var otherShowDeploy = gaDataDeploy.otherShowDeploy( gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"name":"Home_Recommend_Catalog","id":"Home_Recommend_Catalog","creative":"Home_Recommend_Catalog","positionPrefix":"Home_Recommend_Catalog"});
			otherShowDeploy.itemShowAction();
			var slickBox = gaDataDeploy.config[classType].box;
			slickBox.on("afterChange",function(event, slick, currentSlide, nextSlide){
				setTimeout(function(){
					otherShowDeploy.itemShowAction();
				},100)
			})
			$(window).resize(function(){
				otherShowDeploy.itemShowAction();
			})
			$(window).scroll(function(){
				otherShowDeploy.itemShowAction();
			})
		}
    }
    homeRecommendCatalog(); 
	
	//首页 推荐分类埋点02
  	function homeRecommendCatalog02_pc()
  	{
		var classType = "homeRecommendCatalog02_pc";
		if(typeof(gaDataDeploy) == "object"  && gaDataDeploy.config[classType].box.length > 0)
		{
			var otherShowDeploy = gaDataDeploy.otherShowDeploy( gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"name":"Home_Recommend_Catalog_02","id":"Home_Recommend_Catalog_02","creative":"Home_Recommend_Catalog_02","positionPrefix":"Home_Recommend_Catalog_02"});
			otherShowDeploy.itemShowAction();
			var slickBox = gaDataDeploy.config[classType].box;
			slickBox.on("click",".left .button p",function(){
				setTimeout(function(){
					otherShowDeploy.itemShowAction();
				},100)
			})
			$(window).resize(function(){
				otherShowDeploy.itemShowAction();
			})
			$(window).scroll(function(){
				otherShowDeploy.itemShowAction();
			})
		}
    }
    homeRecommendCatalog02_pc();  
	
	//首页 推荐分类埋点02
  	function homeRecommendCatalog02_mb()
  	{
		var classType = "homeRecommendCatalog02_mb";
		if(typeof(gaDataDeploy) == "object"  && gaDataDeploy.config[classType].box.length > 0)
		{
			var otherShowDeploy = gaDataDeploy.otherShowDeploy( gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"name":"Home_Recommend_Catalog_02","id":"Home_Recommend_Catalog_02","creative":"Home_Recommend_Catalog_02","positionPrefix":"Home_Recommend_Catalog_02"});
			otherShowDeploy.itemShowAction();
			var slickBox = gaDataDeploy.config[classType].box;
			var slickBoxSwiper = slickBox[0].swiper;
			
			function transitionEndEvent()
			{
				slickBoxSwiper = slickBox[0].swiper;
				if(slickBoxSwiper)
				{
					slickBoxSwiper.on("transitionEnd",function(){
						setTimeout(function(){
							otherShowDeploy.itemShowAction();
						},100)
					})
				}
				else
				{
					setTimeout(transitionEndEvent,500);
				}
			}
			transitionEndEvent();
			
			$(window).resize(function(){
				otherShowDeploy.itemShowAction();
			})
			$(window).scroll(function(){
				otherShowDeploy.itemShowAction();
			})
		}
    }
    homeRecommendCatalog02_mb();  
	
	//首页 红人
  	function homeNetRed(classType)
  	{
		if(typeof(gaDataDeploy) == "object"  && gaDataDeploy.config[classType].box.length > 0)
		{
			var otherShowDeploy = gaDataDeploy.otherShowDeploy( gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"name":"Home_Net_Red","id":"Home_Net_Red","creative":"Home_Net_Red","positionPrefix":"Home_Net_Red"});
			otherShowDeploy.itemShowAction();
			$(window).resize(function(){
				otherShowDeploy.itemShowAction();
			})
			$(window).scroll(function(){
				otherShowDeploy.itemShowAction();
			})
			var box = gaDataDeploy.config[classType].box
			box.on("click",".button",function(){
				otherShowDeploy.itemShowAction();
			})
		}
    }
    homeNetRed("homeNetRed_pc"); 
	homeNetRed("homeNetRed_ipd"); 
	homeNetRed("homeNetRed_mb"); 
  
  	// 首页 mian banner
	function homeMainBanner()
	{
		var classType = "homeMainBanner";
		if(typeof(gaDataDeploy) == "object")
		{
			gaDataDeploy.otherShowDeploy(gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"id":"Flash Sale","name":"Flash Sale","creative":"Home_Banner","positionPrefix":"Home_Banner"});  
		}
	}
	homeMainBanner()
	
	// 首页 mian banner
	function homeThreeImageGrid()
	{
		var classType = "homeThreeImageGrid";
		if(typeof(gaDataDeploy) == "object")
		{
			gaDataDeploy.otherShowDeploy(gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"id":"Point_Banner","name":"Point_Banner","creative":"Home_Banner","positionPrefix":"Home_Banner"});  
		}
	}
	homeThreeImageGrid()
	/***********************************  首页 end *****************************************/
	
	//头部菜单
  	function topTitle()
  	{
		var classType = "topTitle";
		if(typeof(gaDataDeploy) == "object"  && gaDataDeploy.config[classType].box.length > 0)
		{
			var otherShowDeploy = gaDataDeploy.otherShowDeploy( gaDataDeploy.config[classType].box,gaDataDeploy.config[classType].item,{"name":"Top_Title","id":"Top_Title","creative":"Top_Title","positionPrefix":"Top_Title"});
			otherShowDeploy.itemShowAction();
			$(window).resize(function(){
				otherShowDeploy.itemShowAction();
			})
			$(window).scroll(function(){
				otherShowDeploy.itemShowAction();
			})
			var box = gaDataDeploy.config[classType].box
			box.find(gaDataDeploy.config[classType].parentItem).hover(function(){
				otherShowDeploy.itemShowAction();
			})
		}
    }
    topTitle(); 
	
/************************************ 站内促销监控 end **********************************************/		
})